module.exports = __webpack_public_path__ + "img/Consolidated Grain and Barge Co.16f8bd76.png";